import { ActionType } from "../action-types/type";
import { GlobalAlertAction } from "../actions/alertActions";

interface AlertState {
  message: string | null;
  details?: string[];
  alertType: "error" | "warn" | "info" | "success" | null;
}

const initialState: AlertState = {
  message: null,
  details: [],
  alertType: null,
};

export function alertReducer(
  state: AlertState = initialState,
  action: GlobalAlertAction
): AlertState {
  switch (action.type) {
    case ActionType.SET_GLOBAL_ALERT:
      return {
        message: action.payload.message,
        details: action.payload.details,
        alertType: action.payload.alertType,
      };
    case ActionType.CLEAR_GLOBAL_ALERT:
      return initialState;
    default:
      return state;
  }
} 